import './App.css';
import React, {Component} from 'react';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AboutUsPage from './pages/AboutUsPage';
import "./style.css"
import {HashRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import SummerDashPage from './pages/SummerDashPage';

class App extends Component<{},{}>{

    constructor(props: any){
      super(props);
        this.state = {
            
        };
    }

    render() {
      return (
        <Router>
          <Switch>
            <Route path="/Home" component={HomePage}/>
            <Route exact path="/PrivacyPolicy" component={PrivacyPolicyPage}/>
            <Route exact path="/AboutUs" component={AboutUsPage}/>
            <Route exact path="/SummerDash" component={SummerDashPage}/>
            <Redirect to="/Home"/>
          </Switch>
        </Router>
      );
  }
}


export default App;
